import { render, staticRenderFns } from "./info.vue?vue&type=template&id=7d29ed6f&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=7d29ed6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d29ed6f",
  null
  
)

export default component.exports